import type { FC } from 'react';
import { prepareCommentFullName } from '@/Module/Comment/Helper';
import type { IComment } from '@/Module/Comment/Model/DataModel';
import { commentSelectById } from '@/Module/Comment/Store/Selector';
import { useAppSelector } from '@/Module/Store/Hook';
import CommentView from './CommentView';
interface ICommentProps {
  commentId: IComment['id'];
}
const Comment: FC<ICommentProps> = ({
  commentId
}) => {
  const comment = useAppSelector(state => commentSelectById(state, commentId));
  if (!comment) return null;
  return <CommentView commentId={commentId} createdDate={comment.createdDate} description={comment.commentText} fullName={prepareCommentFullName(comment)} comments={comment.comments?.item1} data-sentry-element="CommentView" data-sentry-component="Comment" data-sentry-source-file="Comment.tsx" />;
};
export default Comment;